export default __webpack_public_path__ + "c7bf2f6299810ecc5dbc12e4ea28c845.jpg";